export enum BulkPinningAction {
  PIN = 'pin',
  UNPIN = 'unpin',
}
